/* FRANK14 · bold — le due strade veloci della scheda.
   «Paga ora» e «Paga in 3 rate» fanno la stessa cosa vera: mettono il capo
   nella busta e portano in cassa. Non promettono un pagamento che non
   esiste: la rata si sceglie in cassa (Klarna o PayPal), e la riga sotto
   il bottone lo dice. Senza JavaScript restano fermi e resta il bottone
   normale, che è un <button type="submit"> vero.
   Se il carrello rifiuta l'aggiunta perché il capo c'è già (per esempio
   l'unico pezzo è già nella busta) si va in cassa lo stesso: è quello che
   il cliente voleva. Per gli altri errori il messaggio si vede sopra i
   bottoni, nel riquadro d'errore della scheda (che sta fuori dal form). */
(function () {
  var bottoni = [].slice.call(document.querySelectorAll('[data-compra]'));
  if (!bottoni.length) return;

  function avvisa(b, form, testo) {
    var scheda = form.closest('product-form');
    var scatola = scheda && scheda.querySelector('.product-form__error-message-wrapper');
    var avviso = scatola && scatola.querySelector('.product-form__error-message');
    if (avviso && scatola) {
      avviso.textContent = testo;
      scatola.removeAttribute('hidden');
    } else {
      window.alert(testo);
    }
  }

  /* il capo è già nella busta? (si chiede al carrello vero, non si indovina) */
  function giaNellaBusta(idVariante) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (busta) {
        return (busta.items || []).some(function (riga) { return riga.variant_id === idVariante; });
      })
      .catch(function () { return false; });
  }

  bottoni.forEach(function (b) {
    b.addEventListener('click', function () {
      var form = b.closest('form[data-type="add-to-cart-form"]');
      if (!form) return;
      var campo = form.querySelector('.product-variant-id, [name="id"]');
      if (!campo || !campo.value) return;
      var idVariante = Number(campo.value);
      var dove = b.getAttribute('data-compra-dove') || '/checkout';

      b.classList.add('sta-caricando');
      b.disabled = true;

      var quanti = form.querySelector('[name="quantity"]');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: idVariante, quantity: quanti ? Number(quanti.value) || 1 : 1 }] })
      })
        .then(function (r) { return r.json().then(function (esito) { return { ok: r.ok, esito: esito }; }); })
        .then(function (risposta) {
          var esito = risposta.esito;
          if (risposta.ok && !(esito && esito.status)) { window.location.href = dove; return; }
          /* rifiutato: se il capo c'è già nella busta si va in cassa lo stesso */
          return giaNellaBusta(idVariante).then(function (c_e) {
            if (c_e) { window.location.href = dove; return; }
            /* i messaggi del carrello a volte arrivano in inglese («Cannot find variant»): si scrive il nostro */
            var rifiuto = new Error('Questo capo adesso non si può mettere nella busta: scegli un\'altra taglia o riprova tra poco.');
            rifiuto.rifiuto = true;
            throw rifiuto;
          });
        })
        .catch(function (e) {
          b.classList.remove('sta-caricando');
          b.disabled = false;
          var testo = e && e.rifiuto
            ? e.message
            : 'Non è riuscito: controlla la connessione e riprova.';
          avvisa(b, form, testo);
        });
    });
  });
})();
